import React from 'react';
import _ from 'lodash';
import { contentfulModels, contentfulViews } from '@glowforge/ui-common';


import MaterialsDisplay from './materials-display';

const { widgetDefaultProps, widgetPropType } = contentfulModels;
const { getSectionForPageByIdAndType, getContentFieldsByType } = contentfulModels;
const { Image } = contentfulViews;

/**
 * MaterialsDisplay Contentful accessor widget.
 * Maps Contentful data to the MaterialsDisplay widget.
 * @param {Object} widget WidgetPropType ui-common/models/widget
 */
class MaterialsDisplayWidget extends React.PureComponent {
  render() {
    const {
      sections,
    } = this.props;

    const ctaProps = getSectionForPageByIdAndType(
      { sections },
      'learn-more-about-materials',
      'buttonLink',
    );

    const andMoreButtonProps = getSectionForPageByIdAndType(
      { sections },
      'materials-homepage-and-dozens-more',
      'buttonLink',
    );

    const materialsListContent = getContentFieldsByType(sections, 'list')[0];

    const sectionTitle = _.get(materialsListContent, 'title');
    const description = _.get(materialsListContent, 'text');

    const items = _.get(materialsListContent, 'listItems').map(({ fields }) => ({
      title: _.get(fields, 'title'),
      image: <Image media={_.get(fields, 'images[0]')} />,
    }));
    return (
      <MaterialsDisplay
        items={items}
        andMoreButtonProps={andMoreButtonProps}
        ctaProps={ctaProps}
        title={sectionTitle}
        description={description} />
    );
  }
}

MaterialsDisplayWidget.propTypes = { ...widgetPropType };

MaterialsDisplayWidget.defaultProps = { ...widgetDefaultProps };

export default MaterialsDisplayWidget;




// WEBPACK FOOTER //
// ./app/components/landing/materials-display-widget.jsx